import httpRequest from '../../utils/httpRequest'

export const SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING'

export const SET_NOT_LOGIN_NOTIFY = 'SET_NOT_LOGIN_NOTIFY'

export const SET_CONFIRM_AUTH_ELE = 'SET_CONFIRM_AUTH_ELE'

export const SET_IS_IPVALIDATE = 'SET_IS_IPVALIDATE'

export const SET_SHOW_IPVALIDATION = 'SET_SHOW_IPVALIDATION'

export const SET_FINGER_PRINT = 'SET_FINGER_PRINT'

export const setLoading = data => dispatch =>
  dispatch({
    type: SET_GLOBAL_LOADING,
    data,
  })

export const setFingerPrint = data => dispatch =>
  dispatch({
    type: SET_FINGER_PRINT,
    data,
  })

export const setShowIpValidation = data => dispatch =>
  dispatch({
    type: SET_SHOW_IPVALIDATION,
    data,
  })

export const setNotLoginNotify = data => dispatch =>
  dispatch({
    type: SET_NOT_LOGIN_NOTIFY,
    data,
  })

export const setTriggerElement = data => dispatch =>
  dispatch({
    type: SET_CONFIRM_AUTH_ELE,
    data,
  })

export const setIpValidate = data => dispatch =>
  dispatch({
    type: SET_IS_IPVALIDATE,
    data,
  })

export const getIpValidation = () => async dispatch => {
  try {
    const res = await httpRequest.ipValidate()
    dispatch(setIpValidate(res))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
  }
}
